module.exports = __webpack_public_path__ + "img/banner3.410dcf1b.jpg";